import {
  ClipboardList,
  UserRound,
  MapPin,
  Building2,
  Home,
  Wallet,
  Calendar,
  Percent,
  Receipt,
  Gauge,
  ExternalLink,
  Coins,
  Bookmark,
  Scale,
  Building,
  KeyRound,
} from "lucide-react";

/* Mortgage calculator tour content, ported from the mobile "Mortgage
   Calculator" mockup. The generic GuidedTour engine renders these; this is
   just the data. Steps whose target is missing (e.g. Saved scenarios when
   the user has none) auto-skip. */
export default function getMortgageTourSteps() {
  return [
    {
      cardSelector: '[data-tour="mc-saved"]',
      targetSelector: '[data-tour="mc-saved"]',
      icon: <ClipboardList />,
      title: "Saved scenarios",
      text: "Your saved calculations live here. Tap any card to instantly reload its data.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-role"]',
      icon: <UserRound />,
      title: "Nursing role",
      text: "Set your role — the numbers below adjust to typical pay for it.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-state"]',
      icon: <MapPin />,
      title: "State",
      text: "Pick the state you're looking at.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-city"]',
      icon: <Building2 />,
      title: "City",
      text: "Choose a city and median home price, taxes and pay all update together.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-price"]',
      icon: <Home />,
      title: "Home price",
      text: "Defaults to the local median — edit it to price a specific listing.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-down"]',
      icon: <Wallet />,
      title: "Down payment",
      text: "Slide from 3% to 50% down; the payment recalculates live.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-term"]',
      icon: <Calendar />,
      title: "Loan term",
      text: "Compare a 15-year payoff against a 30-year loan.",
    },
    {
      cardSelector: '[data-tour="mc-inputcard"]',
      targetSelector: '[data-tour="mc-rate"]',
      icon: <Percent />,
      title: "Interest rate",
      text: "Defaults to today's average — enter your quoted rate.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-total"]',
      icon: <Wallet />,
      title: "Your estimated monthly payment",
      text: "Principal, interest, taxes and insurance combined into one number.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-totalrow"]',
      icon: <Receipt />,
      title: "Monthly breakdown",
      text: "The line-by-line breakdown behind that number.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-afford"]',
      icon: <Gauge />,
      title: "Can you afford this?",
      text: "Compares the payment to local take-home pay.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-sofi"]',
      icon: <ExternalLink />,
      title: "Get pre-qualified",
      text: "Check real rates from lenders without a credit hit — tap Learn more.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-downreq"]',
      icon: <Coins />,
      title: "Down payment required",
      text: "The upfront cash you'll need before closing.",
    },
    {
      cardSelector: '[data-tour="mc-results"]',
      targetSelector: '[data-tour="mc-savebtn"]',
      icon: <Bookmark />,
      title: "Save scenario",
      text: "Bookmark this setup to compare later from your profile.",
    },
    {
      cardSelector: '[data-tour="mc-rentown"]',
      targetSelector: '[data-tour="mc-rentown"]',
      icon: <Scale />,
      title: "Renting vs owning",
      text: "A side-by-side for this city so the trade-off is clear.",
    },
    {
      cardSelector: '[data-tour="mc-rentown"]',
      targetSelector: '[data-tour="mc-rentbar"]',
      icon: <Building />,
      title: "Rent (1-bed median)",
      text: "What a comparable one-bedroom rents for here.",
    },
    {
      cardSelector: '[data-tour="mc-rentown"]',
      targetSelector: '[data-tour="mc-ownbar"]',
      icon: <KeyRound />,
      title: "Own (full mortgage)",
      text: "Your full estimated monthly cost to own.",
    },
    {
      cardSelector: '[data-tour="mc-ctas"]',
      targetSelector: '[data-tour="mc-zillow"]',
      icon: <ExternalLink />,
      title: "Zillow",
      text: "Browse live listings for this city on Zillow.",
    },
    {
      cardSelector: '[data-tour="mc-ctas"]',
      targetSelector: '[data-tour="mc-redfin"]',
      icon: <ExternalLink />,
      title: "Redfin",
      text: "Browse live listings for this city on Redfin.",
    },
  ];
}
